import {
  SR_API_ACTION_ADMIN_GET_PINNED_LISTINGS,
} from 'api/actionTypes';

export default async function getPinnedListings({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_PINNED_LISTINGS,
    state: state,
    onSuccess(listings) {
      state.set(['pinnedListings'], listings);
    },
  });
}
